import { useSseEvent } from './useSseEvent';

const NEW_TRANSACTION_EVENT_TYPE = 'TRANSACTION';
const THROTTLING_DELAY = 2000;

export interface NewTransactionEventPayload {
    productId: string;
    transactionId: string;
}

export function useNewTransactionEvent(
    onEvent: (payload: NewTransactionEventPayload[]) => void,
): void {
    useSseEvent({
        eventType: NEW_TRANSACTION_EVENT_TYPE,
        onEvent,
    });
}

export function useNewTransactionEventThrottled(
    onEvent: (payload: NewTransactionEventPayload[][]) => void,
): void {
    useSseEvent({
        eventType: NEW_TRANSACTION_EVENT_TYPE,
        onEvent,
        // TRANSACTION event is dispatched while the new Transaction is still in process of writing to Elasticsearch.
        // An immediate call to GAPI my/transactions may therefore not return the new Transaction as expected.
        // We introduce a delay before the event handler is invoked to mitigate this issue.
        throttleSettings: { leading: false, trailing: true },
        throttleWait: THROTTLING_DELAY,
    });
}
